'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { useDropdown } from '@/app/_lib/hooks';
import { decodeEntities } from '@/app/_lib/services/ClientUtil';

/**
 * SubProductSelect - Dropdown for navigating between sub-products that share the same product_id
 *
 * Styled exactly like ProductOptionSelect but options are navigation links.
 * The current sub-product is always listed first and shown as selected.
 */
export default function SubProductSelect(t0) {
  const $ = _c(6);
  const {
    currentSubProduct,
    relatedProducts,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const options = [{
    sub_product_id: currentSubProduct.sub_product_id,
    sub_product_name: currentSubProduct.sub_product_name,
    url: null
  }, ...relatedProducts.map(_temp)];
  const selectedOption = options[0];
  const selectedValue = currentSubProduct.sub_product_id;
  const {
    isOpen,
    focusedIndex,
    containerRef,
    getTriggerProps,
    getListProps,
    getItemProps,
    close
  } = useDropdown({
    items: options,
    onSelect: _temp2,
    selectedValue,
    getItemValue: _temp3,
    isItemSelectable: _temp4,
    identifier: "sub-product-select",
    preventOutsideClickPropagation: true
  });
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="sub-product-select-label" className="sr-only">{"Product Variation"}</div>;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== getTriggerProps) {
    t3 = getTriggerProps();
    $[1] = getTriggerProps;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="absolute -top-[.9rem] indent-0 text-xs capitalize text-light">{"Product Variation"} <FontAwesomeIcon icon={faCheck} className="text-primary text-2xs ml-0.5" /></span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = `text-xs text-light transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`;
  let t6;
  if ($[4] !== t5) {
    t6 = <div className="flex items-center gap-2"><FontAwesomeIcon icon={faChevronRight} className={t5} aria-hidden="true" /></div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return <div ref={containerRef} className={`group relative min-h-[1.5rem] border-b ${isOpen ? "border-primary" : "border-gray-10"} hover:border-primary ${className}`}>{t2}<button type="button" className={`flex items-center justify-between w-full min-h-[44px] md:min-h-[2rem] py-2 md:py-1 transition-all duration-100 bg-transparent border-none text-left focus:outline-none relative ${isOpen ? "z-[1000] text-primary" : ""}`} aria-labelledby="sub-product-select-label" {...t3}><span className="transition-all duration-500 text-sm md:text-base flex-1">{t4}<div className={`flex items-center gap-1 group-hover:pl-1 transition-all duration-500 ${isOpen ? "pl-1" : ""}`}><span className="capitalize text-dark group-hover:text-light-3 transition-colors duration-500">{decodeEntities(selectedOption.sub_product_name)}</span></div></span>{t6}</button>{isOpen && <ul className="absolute top-full left-0 w-full bg-white border border-gray-10 shadow-xl z-[1060] max-h-[400px] overflow-y-auto" {...getListProps()}>{options.map((option, index) => {
        const isCurrentProduct = option.sub_product_id === currentSubProduct.sub_product_id;
        if (isCurrentProduct) {
          return <li key={option.sub_product_id} {...getItemProps(option, index)}><div className={`flex items-center w-full py-3 pl-3 pr-7 md:py-2 md:pl-2 md:pr-5 bg-gray-5 text-left text-base cursor-default ${index < options.length - 1 ? "border-b border-gray-5" : ""}`}><span className="text-dark flex-1 capitalize">{decodeEntities(option.sub_product_name)}</span><FontAwesomeIcon icon={faCheck} className="text-primary text-xs" /></div></li>;
        }
        return <li key={option.sub_product_id} {...getItemProps(option, index)}><Link href={option.url} className={`flex items-center w-full py-3 pl-3 pr-7 md:py-2 md:pl-2 md:pr-5 bg-white text-left text-base hover:bg-gray-5 cursor-pointer ${focusedIndex === index ? "bg-gray-5" : ""} ${index < options.length - 1 ? "border-b border-gray-5" : ""}`} onClick={close}><span className="text-dark capitalize">{decodeEntities(option.sub_product_name)}</span></Link></li>;
      })}</ul>}</div>;
}
function _temp4(item_0) {
  return !!item_0.sub_product_name;
}
function _temp3(item) {
  return item.sub_product_id;
}
function _temp2() {}
function _temp(product) {
  return {
    sub_product_id: product.sub_product_id,
    sub_product_name: product.sub_product_name,
    url: product.url
  };
}